module.exports = __webpack_public_path__ + "static/img/noData.aa3e8d11.png";